import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductionLineJobQueueView } from "src/components/views/erp/production/jobQueue/ProductionLineJobQueueView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/production/productionLineJobQueue")({
	staticData: { title: i18n.t("production_line_job_queue"), legacyViewKey: "productionLineJobQueuePage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <ProductionLineJobQueueView isActive={isActive} />;
}
